export default "__VITE_ASSET__984ac588__"